import React from 'react';
import { Flex, useBreakpointValue, useInView } from '@stockx/ui';
import { CatalogImage, PLACEHOLDER_IMAGE_URL } from '@app/catalog';
import { useIsNonInteractiveViewer } from '@app/ui';
import { LegacyProduct } from '@app/types';

const RELEASEPAGE_CALENDAR_IMAGE_WIDTH = 300;
const RELEASEPAGE_CALENDAR_IMAGE_HEIGHT = 214;
const HOME_OR_MOBILE_CALENDAR_IMAGE_WIDTH = 140;
const HOME_OR_MOBILE_CALENDAR_IMAGE_HEIGHT = 75;

interface CalendarTileImageProps {
  product: LegacyProduct;
  isHomepage: boolean;
  isPriority: boolean;
}

const CalendarTileImage = ({
  product,
  isHomepage,
  isPriority = false,
}: CalendarTileImageProps) => {
  const { isMobile } = useBreakpointValue();
  const { title = 'Product', media: { smallImageUrl = null } = {} } = product;
  const isNonInteractiveViewer = useIsNonInteractiveViewer();
  const imgWidth =
    isHomepage || isMobile
      ? HOME_OR_MOBILE_CALENDAR_IMAGE_WIDTH
      : RELEASEPAGE_CALENDAR_IMAGE_WIDTH;

  const imgHeight =
    isHomepage || isMobile
      ? HOME_OR_MOBILE_CALENDAR_IMAGE_HEIGHT
      : RELEASEPAGE_CALENDAR_IMAGE_HEIGHT;

  const [ref, inView] = useInView({
    triggerOnce: true,
    initialInView: isNonInteractiveViewer,
  });

  return (
    <Flex
      width={`${imgWidth}px`}
      height={`${imgHeight}px`}
      mx={{ base: isHomepage ? 2 : 0, lg: isHomepage ? 4 : 0 }}
      my={{ base: isHomepage ? 2 : 0, lg: isHomepage ? 5 : 0 }}
      maxWidth="100%"
      margin="0px auto"
      justifyContent="center"
      ref={ref}
    >
      <CatalogImage
        maxWidth="100%"
        objectFit="contain"
        src={
          (inView || isPriority) && smallImageUrl
            ? smallImageUrl
            : PLACEHOLDER_IMAGE_URL
        }
        aria-hidden="true"
        alt={title}
        width={imgWidth}
        height={imgHeight}
        isPriority={isPriority}
      />
    </Flex>
  );
};

export default CalendarTileImage;
